import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { UNAPPROVE_APPLICATION_LIST } from 'manager/http-constants';
import { CONSTANT } from 'src/app/shared/constant/constant';
import { CommonService } from 'src/app/shared/service/common.service';
import { DbOperationService } from 'src/app/shared/service/db-operation.service';
import { LoadingState } from 'src/app/shared/html-parts/loading/loading-state';
import { PlatformComponent } from '../../platform.component';
import { Table } from 'primeng/table';

@Component({
  selector: 'app-d211',
  templateUrl: './d211.component.html',
  styleUrls: [
    '../secretariat-list.component.scss',
    '../../platform.component.scss',
  ],
})

/**
 * 入会申請一覧
 */
export class D211Component extends PlatformComponent {
  // 画面.検索フォーム
  secretariatSearchForm: FormGroup = this.formBuilder.group({
    // ステータス・ シングルセレクト
    status: '1',
    // 会員名
    organization_name: CONSTANT.EMPTY_STRING,
    // 期間日from
    date1: CONSTANT.EMPTY_STRING,
    // 期間日to
    date2: CONSTANT.EMPTY_STRING,
  });

  /** テーブル状態 */
  @ViewChild('table') table: Table;

  // ステータス取得格納先
  statusList: object[] = [
    {
      sp_name: '全て',
      sp_code: '',
    },
    {
      sp_name: '未承認',
      sp_code: '1',
    },
    {
      sp_name: '非承認',
      sp_code: '2',
    },
    {
      sp_name: '承認',
      sp_code: '3',
    },
    {
      sp_name: '要修正',
      sp_code: '4',
    },
  ];

  // 検索結果一覧表示
  resultTaskDataList: object[] = [];

  // 件数格納先
  countTaskData = 0;

  constructor(
    public route: ActivatedRoute,
    public commonService: CommonService,
    public dbOperationService: DbOperationService,
    public loadingState: LoadingState,
    private router: Router,
    private formBuilder: FormBuilder
  ) {
    super(route, commonService, dbOperationService, loadingState);
  }

  ngOnInit(): void {
    // 提案結果を取得
    this.getResultTaskDataList();
  }

  /**
   * 入会申請登録結果を取得
   */
  public getResultTaskDataList(): void {
    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(UNAPPROVE_APPLICATION_LIST);

    // 入会申請結果を取得
    this.dbOperationService
      .getNoTemplateData(
        UNAPPROVE_APPLICATION_LIST,
        this.secretariatSearchForm.value,
        false
      )
      .subscribe((response) => {
        if (!this.commonService.checkNoneResponse(response)) {
          // 入会申請検索結果結果を格納
          this.resultTaskDataList = response.body;
        } else {
          this.resultTaskDataList = [];
        }

        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, UNAPPROVE_APPLICATION_LIST);
      });

    // テーブル状態が存在するか否か
    if (this.table) {
      // テーブル状態が存在する場合

      // テーブル状態をリセット
      this.table.reset();
    }
  }

  /**
   * 入会申請詳細(A231)へ遷移する
   * @param application_id 申請ID
   */
  public moveA231(application_id: string): void {
    // 入会申請詳細(A231)へ遷移
    this.router.navigate(['pages/platform/a231/' + application_id]);
  }
}
